import { gql } from '@apollo/client';

export * from './backupMemberRemove.mutation.generated';

export const BACKUP_MEMBER_REMOVE = gql`
  mutation backupMemberRemove($backupMemberId: ID!) {
    backupMemberRemove(input: { backupMemberId: $backupMemberId }) {
      errors
      success
    }
  }
`;
